import { RotateCcw } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

interface RefreshButtonProps {
  onRefresh:     () => void;
  isRefreshing:  boolean;
  lastRefreshed: Date | null;
  className?:    string;
}

export function RefreshButton({ onRefresh, isRefreshing, lastRefreshed, className = '' }: RefreshButtonProps) {
  const tooltip = lastRefreshed
    ? `Updated ${formatDistanceToNow(lastRefreshed)} ago — click to refresh`
    : 'Refresh';

  return (
    <button
      onClick={onRefresh}
      disabled={isRefreshing}
      title={tooltip}
      aria-label={tooltip}
      className={`flex items-center justify-center p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors disabled:opacity-50 ${className}`}
    >
      <RotateCcw className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
    </button>
  );
}
